import React, { useCallback, useState } from 'react';
import { SidebarLayout } from '../../layouts/MainFrame/Sidebar/SidebarLayout';
import SidebarNavigation from '../../sidebar-navigation/SidebarNavigation';
import { ContentLayout } from '../../layouts/MainFrame/ContentLayout';
import { PageWithSidebarLayout } from '../../layouts/MainFrame/PageWithSidebarLayout';
import { Grid, useMediaQuery, useTheme } from '@mui/material';

export const ControlPagesWrapper: React.FC<{ children?: React.ReactNode, sidebarItems: any }> = (
    props
) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <ContentLayout>
            <Grid container spacing={3}>
                {!isMobile && (
                    <Grid item lg={2} md={3}>
                        <SidebarNavigation sidebarItems={props.sidebarItems}/>
                    </Grid>
                )}

                <Grid item xs>
                    {props.children}
                </Grid>
            </Grid>
        </ContentLayout>
    );
};
